import styled from 'styled-components';
import Modal from 'components/modal';
import Icon from 'components/icons';
import {
  ButtonRow,
  CloseButton,
  Container,
  ContinueButton,
  Subtext,
  Title,
  ZipButton,
} from './styles';

const RoundedModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 20px;
  }
`;

export interface PageExportWarningModalProps {
  open: boolean;
  onClose: () => void;
  onContinuePdf: () => void;
  onExportZip: () => void;
}

const PageExportWarningModal = ({
  open,
  onClose,
  onContinuePdf,
  onExportZip,
}: PageExportWarningModalProps): JSX.Element => (
  <RoundedModal
    visible={open}
    onCancel={onClose}
    footer={null}
    closable={false}
    width={454}
    destroyOnClose
  >
    <Container>
      <CloseButton
        type="button"
        aria-label="Close"
        onClick={onClose}
        data-testid="page-export-warning-close"
      >
        <Icon icon="Close" fill="var(--black-dark)" style={{ width: 24, height: 24 }} />
      </CloseButton>
      <Title>This report contains a table with over 100 rows</Title>
      <Subtext>
        Large tables will be limited to the first 100 rows in the PDF. To include all records,
        export as a bundle (zip).
      </Subtext>
      <ButtonRow>
        <ContinueButton
          type="button"
          onClick={onContinuePdf}
          data-testid="page-export-continue-pdf"
        >
          Continue with PDF
        </ContinueButton>
        <ZipButton type="button" onClick={onExportZip} data-testid="page-export-export-zip">
          Export as Zip (Recommended)
        </ZipButton>
      </ButtonRow>
    </Container>
  </RoundedModal>
);

export default PageExportWarningModal;
